const ITEMS = [
    "Expert Attorney",
    "Expert Attorney",
    "Expert Attorney",
    "Expert Attorney",
];

export const Marquee = () => (
    <div
        className="marquee relative border-y border-white/10 py-7 md:py-9 overflow-hidden bg-ink-900"
        aria-hidden="true"
    >
        <div className="marquee-track">
            {[0, 1].map((copy) => (
                <div key={copy} className="flex items-center shrink-0">
                    {ITEMS.map((item, i) => (
                        <span key={`${copy}-${i}`} className="flex items-center">
                            <span className="font-serif italic text-4xl md:text-6xl text-outline whitespace-nowrap">
                                {item}
                            </span>
                            <span className="mx-8 md:mx-12 text-brass-500/50 text-xl">
                                ·
                            </span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default Marquee;
